// extracted by mini-css-extract-plugin
export default {"headerArea":"Headers_headerArea__3BC11","boxTitle":"Headers_boxTitle__nk2cQ"};